// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Main from './main.vue'

const main_router = 'provider_node'

const router = [
    {
        path: '',
        component: Main,
        name: 'provider_node',
        meta: {
            api_name: "api_v1_provider_update",
            breadcrumb: [main_router]
        }
    },
]

export default router
